import fpApi from 'fp-api';
import createSession from 'fp-api/src/createSession';

import config from '../config';

const { apiInstance, dataSource } = config.settings;

const authCookieName = 'FP_AUTH_TOKEN';

const remote = fpApi({
  baseURI: `${dataSource}/${apiInstance}`,
  cookieName: authCookieName,
  refreshPath: 'auth/refresh'
});

// to manually set the authentication token for draftstars
export const setAuthCookie = jwtCookie => {
  const sessionInstance = createSession(authCookieName);

  sessionInstance.saveToken(jwtCookie);
};

export default remote;
